const translations = {
  "site.name": "必赢亚洲",
  "site.slogan": "安全畅玩赢无止境",
  "site.description": "亚洲顶级娱乐游戏平台",
  "nav.home": "首页",
  "nav.sports": "体育竞技",
  "nav.live": "真人娱乐",
  "nav.slots": "电子游艺",
  "nav.articles": "优惠资讯",
  "nav.about": "关于我们",
  "hero.title": "必赢亚洲·官方正版平台",
  "hero.subtitle": "亚洲顶级娱乐游戏平台，安全畅玩赢无止境",
  "hero.cta": "立即注册",
  "hero.learnMore": "了解更多",
  "categories.title": "热门游戏分类",
  "categories.subtitle": "多元玩法，满足您的每一种娱乐需求",
  "categories.sports": "体育竞技",
  "categories.sports.desc": "覆盖全球主流赛事，实时赔率更新，足球、篮球、网球等热门体育项目一应俱全",
  "categories.live": "真人娱乐",
  "categories.live.desc": "真人荷官在线发牌，高清直播无延迟，百家乐、轮盘、骰宝等经典玩法随时畅享",
  "categories.slots": "电子游艺",
  "categories.slots.desc": "海量精品游戏，精美画面流畅体验，老虎机、捕鱼、棋牌等丰富选择应有尽有",
  "features.title": "为什么选择必赢亚洲",
  "features.subtitle": "六大核心优势，为您打造极致娱乐体验",
  "features.safety": "安全可靠",
  "features.safety.desc": "官方正版授权，多重加密技术保障资金与信息安全",
  "features.speed": "极速到账",
  "features.speed.desc": "存取款秒级处理，多种支付方式自由选择",
  "features.service": "24小时客服",
  "features.service.desc": "全天候专业客服团队，随时为您排忧解难",
  "features.fair": "公平公正",
  "features.fair.desc": "国际认证随机算法，确保每一局游戏公平透明",
  "features.odds": "高赔率",
  "features.odds.desc": "行业领先赔率体系，让您的每一注都物超所值",
  "features.variety": "玩法丰富",
  "features.variety.desc": "体育、真人、电子三大板块，上千款游戏任您挑选",
  "promotions.title": "限时优惠活动",
  "promotions.subtitle": "多重好礼等您来拿，新老玩家皆有福利",
  "promotions.newbie": "新会员首存礼",
  "promotions.newbie.desc": "首次充值即享100%赠送，最高可获888元彩金",
  "promotions.rebate": "每日返水",
  "promotions.rebate.desc": "体育投注享0.8%返水，真人娱乐享0.6%返水，上不封顶",
  "promotions.vip": "VIP专属福利",
  "promotions.vip.desc": "VIP会员专享生日礼金、专属客服、优先提现等特权",
  "promotions.invite": "邀请有礼",
  "promotions.invite.desc": "邀请好友注册并充值，双方各得58元奖励金",
  "testimonials.title": "玩家真实评价",
  "testimonials.subtitle": "来自全球百万玩家的真实声音",
  "faq.title": "常见问题",
  "faq.subtitle": "快速了解必赢亚洲，解答您的疑问",
  "footer.copyright": "© 2024 必赢亚洲 版权所有",
  "footer.disclaimer": "理性娱乐，享受健康生活。未满18周岁禁止参与。",
  "about.title": "关于必赢亚洲",
  "about.brand": "品牌介绍",
  "about.reputation": "信誉口碑",
  "about.contact": "联系我们",
  "breadcrumb.home": "首页",
  "article.readMore": "阅读全文",
  "article.backToList": "返回列表",
  "article.publishDate": "发布时间",
  "article.category": "分类",
  "category.allGames": "全部游戏",
  "scrollToTop": "回到顶部",
};

export default translations;